// extracted by mini-css-extract-plugin
module.exports = {"header":"BackOffice_header__2Ua_2","logo":"BackOffice_logo__15eUL","disconnect":"BackOffice_disconnect__2Vnmn","content":"BackOffice_content__BuL3v"};